import type { FC } from "react";
import { CANCEL_REFUND_TEXT } from "../../../../libs/mypage/cancelRefundText";
import type { OrderDetailDTO } from "../../components/format";
import { LinkButton } from "../../components/LinkButton";
import { buildBankInfoMailto } from "../bankInfoMailto";

/**
 * キャンセル済 (CANCELLED / REFUNDED) のとき、キャンセル完了メールと同じ「ご返金について」の案内を
 * 詳細画面の上部に常時表示する。文言は `CANCEL_REFUND_TEXT` (メール・完了画面と共有)。
 *  - `cash_refund` (= コンビニ/銀行振込で支払済の手動返金ケース): 口座情報を送ってほしい旨と mailto
 *    ボタン。色は amber (要アクション)
 *  - それ以外 (お支払い前 / 自動返金 / NP後払いの請求取り消し): 案内のみ。色は neutral (info)
 */
export const RefundInfoSection: FC<{ order: OrderDetailDTO }> = ({ order }) => {
  const isCancelled = order.status === "CANCELLED" || order.status === "REFUNDED";
  if (!isCancelled) return null;
  const refund = CANCEL_REFUND_TEXT[order.cancelRefundKind];

  if (order.cancelRefundKind === "cash_refund") {
    return (
      <section className="mb-10 rounded border border-amber-200 bg-amber-50 p-4 text-amber-900 text-sm">
        <p className="mb-2 font-medium">{refund.status}</p>
        <p className="text-amber-800 leading-relaxed">
          {refund.body}
          下記ボタンから口座情報をカスタマーサポート宛にお送りください。
        </p>
        <div className="mt-3">
          <LinkButton href={buildBankInfoMailto(order.code)} size="sm">
            口座情報をメールで送る
          </LinkButton>
        </div>
      </section>
    );
  }

  return (
    <section className="mb-10 rounded border border-neutral-200 bg-neutral-50 p-4 text-neutral-700 text-sm">
      <p className="mb-2 font-medium text-neutral-900">{refund.status}</p>
      <p className="leading-relaxed">{refund.body}</p>
    </section>
  );
};
